<template>
  <div>
    <div class="modal-backdrop fade show"></div>
    <div class="modal show d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl  modal-dialog-scrollable">
        <div class="modal-content vh-75 d-flex flex-column">
          <div class="modal-header">
            <h5 class="modal-title">Query Options</h5>
            <button type="button" class="btn-close" aria-label="Close" @click="$emit('close')"></button>
          </div>
          <div class="modal-body flex-fill overflow-hidden">
            <!-- Page content-->
            <div class="row h-100 g-0">
              <!-- Sidebar-->
              <aside class="col-lg-4 col-md-5 border-end bg-light p-3 overflow-auto">
                <!-- Account nav-->
                <div class="card card-body border-0 shadow-sm pb-1 me-lg-1 h-100">
                  <div class="d-md-block mt-3">
                    <div class="card-nav nav d-flex flex-column" role="tablist">
                      <a class="card-nav-link nav-link" 
                        :class="{ active: activeTab === 'datasections' }"
                        href="#" 
                        @click.prevent="setActiveTab('datasections')"
                        role="tab">
                        <i class="bi bi-grid-1x2 opacity-60 me-2"></i>Output options
                      </a>
                      <a class="card-nav-link nav-link" 
                        :class="{ active: activeTab === 'degreedays' }"
                        href="#" 
                        @click.prevent="setActiveTab('degreedays')"
                        role="tab">
                        <i class="bi bi-tree opacity-60 me-2"></i>Degree Days
                      </a>
                      <a class="card-nav-link nav-link" 
                        :class="{ active: activeTab === 'stationoptions' }"
                        href="#" 
                        @click.prevent="setActiveTab('stationoptions')"
                        role="tab">
                        <i class="bi bi-three-dots-vertical opacity-60 me-2"></i>Weather Stations
                      </a>
                      <a class="card-nav-link nav-link" 
                        :class="{ active: activeTab === 'histfcst' }"
                        href="#" 
                        @click.prevent="setActiveTab('histfcst')"
                        role="tab">
                        <i class="bi bi-clock-history opacity-60 me-2"></i>Historical forecast
                      </a>
                      <a class="card-nav-link nav-link" 
                        :class="{ active: activeTab === 'radar' }"
                        href="#" 
                        @click.prevent="setActiveTab('radar')"
                        role="tab">
                        <i class="bi bi-broadcast opacity-60 me-2"></i>Radar data
                      </a>
                    </div>
                  </div>
                </div>
              </aside>
              <!-- Content-->
              <div class="col-lg-8 col-md-7 px-3 py-2 overflow-auto h-100">
                <div class="tab-content">
                  <!-- Data sections tab -->
                  <div v-if="activeTab === 'datasections'" class="tab-pane active show" role="tabpanel">
                    
                    <div class="mt-4 text-primary h6">Output options</div>
                    <p class="form-text"> 
                      Options change the way the data is retrieved or presented. 
                    </p>
                    <div class="form-check form-check-inline" >
                      <input type="checkbox" id="optionsnonulls"  v-model="optionsnonulls" class="form-check-input"/>
                      <label class="form-check-label" for="optionsnonulls">Omit empty (null) values</label>
                    </div>
                    <div class="form-check form-check-inline" >
                      <input type="checkbox" id="optionsstnslevel1"  v-model="optionsstnslevel1" class="form-check-input"/>
                      <label class="form-check-label" for="optionsstnslevel1">Include only level 1 stations</label>
                    </div>
                    <div class="form-check form-check-inline" >
                      <input type="checkbox" id="optionsuseobs"  v-model="optionsuseobs" class="form-check-input"/>
                      <label class="form-check-label" for="optionsuseobs">Use station observations</label>
                    </div>
                    <div class="form-check form-check-inline" >
                      <input type="checkbox" id="optionsuseremote"  v-model="optionsuseremote" class="form-check-input"/>
                      <label class="form-check-label" for="optionsuseremote">Use remote observations</label>
                    </div>
                    <div class="form-check form-check-inline" >
                      <input type="checkbox" id="optionsfcst"  v-model="optionsfcst" class="form-check-input"/>
                      <label class="form-check-label" for="optionsfcst">Include forecast</label>
                    </div>
                    <div class="form-check form-check-inline" >
                      <input type="checkbox" id="optionsstatsfcst"  v-model="optionsstatsfcst" class="form-check-input"/>
                      <label class="form-check-label" for="optionsstatsfcst">Include hourly statistical forecast</label>
                    </div>
                    <div class="mb-3">
                      <label class="form-label fw-semibold">Minute interval</label>
                      <select class="form-select form-select-sm" style="max-width: 200px;" v-model="optionsminuteinterval" >
                        <option disabled value="">&nbsp;</option>
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                      </select>
                      <div class="form-text">
                        Interval between observations in minute-level data.
                      </div>
                    </div>
                  </div>
                  <!-- Degree Days tab -->
                  <div v-if="activeTab === 'degreedays'" class="tab-pane active show" role="tabpanel">
                    <div class="mt-4 text-primary h6">Degree Day Options</div>
                    <p class="form-text"> 
                      Degree days are used in agriculture, heating and cooling applications to measure how the temperature affects the operation of a farm or system. 
                      Degree days are not available in all plans. 
                    </p>
                    <div>
                      <div class="mb-3">
                        <label class="form-label fw-semibold">Base temperature</label>
                        <div class="input-group input-group-sm">
                          <input type="number" class="form-control"  style="max-width:200px"  v-model="localQueryDefinition.degreeDayTempBase"  >
                          <span class="input-group-text" id="basic-addon2" v-html="tempUnitLabel"></span>
                          <button class="btn btn-secondary" type="button" @click="localQueryDefinition.degreeDayTempBase=-999" title="Reset to default"   ><i class="bi bi-arrow-counterclockwise" ></i></button>
                        </div>
                        <div class="form-text">
                          Degree day base temperature
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label fw-semibold">Maximum temperature threshold</label>
                        <div class="input-group input-group-sm">
                          <input type="number" class="form-control"  style="max-width:200px"  v-model="localQueryDefinition.degreeDayTempMaxThreshold"  >
                          <span class="input-group-text" id="basic-addon2" v-html="tempUnitLabel"></span>
                          <button class="btn btn-secondary" type="button" @click="localQueryDefinition.degreeDayTempMaxThreshold=-999" title="Reset to default"  ><i class="bi bi-arrow-counterclockwise" ></i></button>
                        </div>
                        <div class="form-text">
                          Degree day maximum temperature
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label fw-semibold">Calculation method</label>
                        <select class="form-select form-select-sm" style="max-width:200px"  v-model="localQueryDefinition.degreeDayMethod" >
                          <option disabled value="">&nbsp;</option>
                          <option v-for="(u,i) in DEGREEDAYMETHODS" :value="u">{{u}}</option>
                        </select>
                        <div class="form-text">
                          Degree day calculation method
                        </div>
                      </div>
                      <div class="mb-3">
                        <div class="form-check form-check-inline ">
                          <input type="checkbox"  id="ddInverse" v-model="localQueryDefinition.degreeDayInverse" class="form-check-input"   />
                          <label class="form-check-label" for="ddInverse">Invert calculation method</label>
                        </div>
                        <div class="form-text">
                          Invert calculation method to increase degree days with decreasing temperature
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label fw-semibold">Start date</label>
                        <div class="input-group input-group-sm">
                          <input type="text" class="form-control"  style="max-width:200px"  v-model="localQueryDefinition.degreeDayStartDate"  >
                          <button class="btn btn-secondary" type="button" @click="localQueryDefinition.degreeDayStartDate=null" title="Reset to default"  ><i class="bi bi-arrow-counterclockwise" ></i></button>
                        </div>
                        <div class="form-text">
                          Fixed start date for degree day accumulation (yyyy-MM-dd such as 2021-02-15)
                        </div>
                      </div>
                      <div class="mb-3">
                        <label class="form-label fw-semibold">Fix Temperature</label>
                        <div class="input-group input-group-sm">
                          <input type="number" class="form-control"  style="max-width:200px"  v-model="localQueryDefinition.degreeDayTempFix"  >
                          <span class="input-group-text" id="basic-addon2" v-html="tempUnitLabel"></span>
                          <button class="btn btn-secondary" type="button" @click="localQueryDefinition.degreeDayTempFix=-999" title="Reset to default"  ><i class="bi bi-arrow-counterclockwise" ></i></button>
                        </div>
                        <div class="form-text">
                          Degree day fix temperature  
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Historical forecast tab -->
                  <div v-if="activeTab === 'histfcst'" class="tab-pane active show" role="tabpanel">
                    <div class="mt-4 text-primary h6">Historical forecast</div>
                    <p class="form-text"> 
                      Provides previous date forecasts. Please note that these may require a specific license or plan.   See the <a href="/resources/documentation/weather-api/timeline-weather-api/">API documentation</a> for more information. 
                    </p>
                    <div class="mb-3">
                      <label class="form-label fw-semibold">Historical forecast basis date</label>
                      <div class="input-group input-group-sm">
                        <input type="text" class="form-control"  style="max-width:200px"  v-model="localQueryDefinition.forecastBasisDate "  >
                        <button class="btn btn-secondary" type="button" @click="localQueryDefinition.forecastBasisDate=null" title="Reset to default" ><i class="bi bi-arrow-counterclockwise" ></i></button>
                      </div>
                      <div class="form-text">
                        Start date for historical forecast (yyyy-MM-dd format such as 2022-02-15)
                      </div>
                    </div>
                    <div class="mb-3">
                      <label class="form-label fw-semibold">Historical forecast basis day</label>
                      <div class="input-group input-group-sm">
                        <input type="number" class="form-control" min="0" max="15" step="1" style="max-width:200px"  v-model="localQueryDefinition.forecastBasisDay">
                        <button class="btn btn-secondary" type="button" @click="localQueryDefinition.forecastBasisDay=null" title="Reset to default" ><i class="bi bi-arrow-counterclockwise" ></i></button>
                      </div>
                      <div class="form-text">
                        Forecast basis day for the start date of the query.
                      </div>
                    </div>
                  </div>
                  <!-- Radar tab -->
                  <div v-if="activeTab === 'radar'" class="tab-pane active show" role="tabpanel" id="radar" >
                    <div class="mt-4 text-primary h6">Radar data options</div>
                    <p class="form-text"> 
                      Options to include precipitation data from weather radar.   See the <a href="/resources/documentation/weather-data/how-to-include-weather-radar-data-in-weather-datasets/">radar documentation</a> for more information. 
                    </p>
                    <div class="mb-3">
                      <label class="form-label fw-semibold">Radar threshold</label>
                      <div class="input-group input-group-sm">
                        <input type="number" class="form-control"  style="max-width:200px" v-model="optionsradarthreshold">
                        <span class="input-group-text" id="basic-addon2" v-html="distanceUnitLabel"></span>
                        <button class="btn btn-secondary" type="button" @click="optionsradarthreshold=0" title="Reset to default" ><i class="bi bi-arrow-counterclockwise" ></i></button>
                      </div>
                      <div class="form-text">
                        Station distance at which radar is used to populate precip value rather than nearyby station.
                      </div>
                    </div>
                  </div>
                  <!-- Weather stations tab -->
                  <div v-if="activeTab === 'stationoptions'" class="tab-pane active show" role="tabpanel" id="stationoptions" >
                    <div class="mt-4 text-primary h6">Weather stations</div>
                    <p class="form-text"> 
                      Options to modify how nearby weather stations data is used to calculate historical observations. 
                    </p>
                    <div class="mb-3">
                      <label class="form-label fw-semibold">Maximum distance</label>
                      <div class="input-group input-group-sm">
                        <input type="number" class="form-control"  style="max-width:200px" v-model="convertedMaxdistance">
                        <span class="input-group-text" id="basic-addon2" v-html="distanceUnitLabel"></span>
                        <button class="btn btn-secondary" type="button" @click="localQueryDefinition.maxDistance=-1" title="Reset to default" ><i class="bi bi-arrow-counterclockwise" ></i></button>
                      </div>
                      <div class="form-text">
                        API Parameter distance: {{apiMaxDistance}}. Maximum allowed value: {{maxDistanceMax+distanceUnitLabel}}
                      </div>
                    </div>
                    <div class="mb-3">
                      <label  class="form-label fw-semibold">Maximum stations</label>
                      <div class="input-group input-group-sm">
                        <input type="number" class="form-control" style="max-width:200px"  v-model="localQueryDefinition.maxStations" >
                      </div>
                      <div class="form-text">
                        Number of weather stations used to interpolate historical observations.
                      </div>
                    </div>
                    <div class="mb-3">
                      <label  class="form-label fw-semibold">Maximum elevation difference</label>
                      <div class="input-group input-group-sm">
                        <input type="number" class="form-control" style="max-width:200px"  v-model="localQueryDefinition.elevationDifference" >
                      </div>
                      <div class="form-text">
                        Allowed difference in elevation between requested location and stations (meters) 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$emit('close')">Close</button>
            <button type="button" class="btn btn-primary" @click="$emit('save', localQueryDefinition)">Save changes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VcConversion} from '/src/visualcrossing-core/vcconversion'
import {VcListUtils} from '/src/visualcrossing-core/vclistutils'
import ContentTypeChooser from '/src/components/ContentTypeChooser.vue'

export default {
  name: 'queryEditor',
  props: {
    queryDefinition: Object,  
    startSection: String
  },
  emits: ['update:querydefinition', 'close', 'save'],
  data() {
    return {
      // Vue state for tab control
      activeTab: 'datasections',
      
      // Vue state for accordion control
      accordionSections: {
        coreWeather: true, // Set some to true by default for testing
        astronomy: false,
        description: false,
        additionalInfo: false
      },

      breakBys: [
        {id:"years",label:"Years"},
        {id:"self",label:"Self"},
        {id:"none",label:"None"},
      ],
      chronoUnits:[
        {id:"years",label:"Year"},
        {id:"months",label:"Month"},
        {id:"weeks",label:"Week"},
        {id:"days",label:"Day"},
        // {id:"all",label:"Summarize all data"},
      ],
      combinationMethods:[
        {id:"aggregate",label:"aggregate"},
        {id:"list",label:"list"},
        {id:"best",label:"best"},
        {id:"raw",label:"raw"},
      ],
      DEGREEDAYMETHODS:[
        "average","sine","doublesine","triangle","doubletriangle"
      ],
      periods:[
        {id:"today",label:"today"},
        {id:"yesterday",label:"yesterday"},
        {id:"yeartodate",label:"yeartodate"},
        {id:"monthtodate",label:"monthtodate"},
        {id:"last7days",label:"last7days"},
        {id:"last30days",label:"last30days"},
        {id:"lastyear",label:"lastyear"},
        {id:"last24hours",label:"last24hours"},
      ],
      years:[],
      months:[
        {id:1,label:"January", days:31},
        {id:2,label:"February", days:28},
        {id:3,label:"March", days:31},
        {id:4,label:"April", days:30},
        {id:5,label:"May", days:31},
        {id:6,label:"June", days:30},
        {id:7,label:"July", days:31},
        {id:8,label:"August", days:31},
        {id:9,label:"September", days:30},
        {id:10,label:"October", days:31},
        {id:11,label:"November", days:30},
        {id:12,label:"December", days:31},
      ],
      includes:[
        {
          id:"obs",
          label:"Historical station observations",
          value:false,
          def:true,
        },
        {
          id:"remote",
          label:"Historical remote observations (satellite, radar)",
          value:false,
          def:true,
        },
        {
          id:"stats",
          label:"Statistics",
          value:false,
          def:false,
        },
        {
          id:"statsfcst",
          label:"Statistical forecast",
          value:false,
          def:false,
        },
        {
          id:"histfcst",
          label:"Forecast as history",
          value:false,
          def:false,
        },
        {
          id:"fcst",
          label:"Forecast",
          value:false,
          def:true,
        },
       /* {
          id:"days",
          label:"Daily data",
          value:false
        },
        {
          id:"hours",
          label:"Hourly data",
          value:false
        },
        {
          id:"alerts",
          label:"Weather alerts",
          value:false
        },
        {
          id:"current",
          label:"Current conditions",
          value:false
        },
        {
          id:"events",
          label:"Weather events",
          value:false
        }    */       
      ],

      startDate:{
          year:null,
          month:null,
          day:null
        },
        endDate:{
          year:null,
          month:null,
          day:null
        },
        datemode:"none",
        showAdvanced:false,
        advancedSection:"core",
        localQueryDefinition:this.createLocationDefinition(),
    }
      
    },
    methods:{
      // New tab control methods
      setActiveTab(tabName) {
        this.activeTab = tabName;
      },

      // New accordion control methods
      toggleAccordion(sectionName) {
        this.accordionSections[sectionName] = !this.accordionSections[sectionName];
      },
      isDefaultInclude(id) {
        var selectedIncludes = this.includes;
        return selectedIncludes.reduce(function(a,d) {
          return a || (d.id === id && d.def);
        }, false);
      },
      createLocationDefinition(defn) {
        defn = defn || this.queryDefinition;
        return defn && JSON.parse(JSON.stringify(defn));
      },
      getQueryDefn() {
        console.log("getQueryDefn...")
        return this.localQueryDefinition;
      },
     
     toggleAdvSection(section) {
        this.advancedSection=section!==this.advancedSection?section:null;
      },
      showAdvSection(section) {
        return this.advancedSection===section;
      },
      
      daysInMonth:function(month, startDay) {
          var me=this;
          var days=[];
          month=+month;
          if (startDay) startDay--;
          if (!month || !me.months[month-1]) return days;
          for (var i=0;i<me.months[month-1].days;i++) {
            if (!startDay || i>=startDay) days.push(i+1);
          }
          return days;
        },
     
     
    },
    computed:{
       
        datasourceIncludes() {
          return VcListUtils.filterArrayById(["obs","remote","fcst","stats","statsfcst"], this.includes);
        },
        defaultIncludes() {

          var selectedIncludes=this.includes;
          return !selectedIncludes.reduce(function(a,d) {
            return a || d.value
          }, false);
      
        },
        
      /*
        degreedayIncludes() {
          var me=this;
          return VcListUtils.filterArrayById(["degreeday","accdegreeday"], me.includes);
        },*/
        apiMaxDistance() {
          if (this.localQueryDefinition.maxDistance===-1) return "Default";
          return this.localQueryDefinition.maxDistance+" meters";
        },
        maxDistanceMax() {
          return Math.round(VcConversion.convertValue(200000, "m", this.distanceUnit))
          // return VcConversion.formatValueFromUnit(val,this.distanceUnit);
        },
        convertedMaxdistance: {
          get: function () {
            var me=this;
            var queryDefn=me.localQueryDefinition;
            if (queryDefn.maxDistance===-1) return "";
           
            return VcConversion.convertValue(queryDefn.maxDistance, "m", me.distanceUnit, 0);
          },
          set: function (newValue) {
            var me=this;
            if (newValue>me.maxDistanceMax) newValue=me.maxDistanceMax;
            if (newValue<-1) newValue=-1;
            var queryDefn=me.localQueryDefinition;
            if (!newValue || newValue<0) {
              queryDefn.maxDistance=-1
            } else {
              queryDefn.maxDistance=Math.round(VcConversion.convertValue(newValue, me.distanceUnit, "m"));
            }

          }
        },
        distanceUnit() {
          return VcConversion.getQuantityUnit(this.localQueryDefinition.unitGroup || "us", "distance");
        },
        distanceUnitLabel() {
          return VcConversion.formatValueFromUnit(null,this.distanceUnit);
        },
        tempUnit() {
          return VcConversion.getQuantityUnit(this.localQueryDefinition.unitGroup || "us", "temp");
        },
        tempUnitLabel() {
          return VcConversion.formatValueFromUnit(null,this.tempUnit);
        },
        optionsnonulls: {
          get: function () {
            return VcListUtils.hasValueInList(this.localQueryDefinition.options, "nonulls");
          },
          set: function (newValue) {
            this.localQueryDefinition.options=VcListUtils.setValueInList(this.localQueryDefinition.options, "nonulls", newValue);
          }
        },
        optionsstnslevel1: {
          get: function () {
            return VcListUtils.hasValueInList(this.localQueryDefinition.options, "stnslevel1");
          },
          set: function (newValue) {
            this.localQueryDefinition.options=VcListUtils.setValueInList(this.localQueryDefinition.options, "stnslevel1", newValue);
          }
        },
        optionsuseremote: {
          get: function () {
            return VcListUtils.hasValueInList(this.localQueryDefinition.options, "useremote");
          },
          set: function (newValue) {
            this.localQueryDefinition.options=VcListUtils.setValueInList(this.localQueryDefinition.options, "useremote", newValue);
          }
        },
        optionsfcst: {
          get: function () {
            return VcListUtils.hasValueInList(this.localQueryDefinition.options, "usefcst");
          },
          set: function (newValue) {
            this.localQueryDefinition.options=VcListUtils.setValueInList(this.localQueryDefinition.options, "usefcst", newValue);
          }
        },
        optionsstatsfcst: {
          get: function () {
            return VcListUtils.hasValueInList(this.localQueryDefinition.options, "usestatsfcst");
          },
          set: function (newValue) {
            this.localQueryDefinition.options=VcListUtils.setValueInList(this.localQueryDefinition.options, "usestatsfcst", newValue);
          }
        },
        optionsuseobs: {
          get: function () {
            return VcListUtils.hasValueInList(this.localQueryDefinition.options, "useobs");
          },
          set: function (newValue) {
            this.localQueryDefinition.options=VcListUtils.setValueInList(this.localQueryDefinition.options, "useobs", newValue);
          }
        },

        optionsminuteinterval: {
          get: function () {
            return VcListUtils.getIntValueInList(this.localQueryDefinition.options, "minuteinterval", 15);
          },
          set: function (newValue) {
            this.localQueryDefinition.options=VcListUtils.setIntValueInList(this.localQueryDefinition.options, "minuteinterval", newValue);
          }
        },

        optionsradarthreshold: {
          get: function () {
            return VcConversion.convertValue(VcListUtils.getIntValueInList(this.localQueryDefinition.options, "radarthreshold"), "m", this.distanceUnit, 0);
          },
          set: function (newValue) {
            newValue=Math.round(VcConversion.convertValue(newValue, this.distanceUnit, "m"));
            this.localQueryDefinition.options=VcListUtils.setIntValueInList(this.localQueryDefinition.options, "radarthreshold", newValue);
          }
        },
        isJson() {
            return this.localQueryDefinition.contentType==="json";
        },
        isTable() {
            return this.localQueryDefinition.contentType!=="json";
        },
    },
    mounted() {
      var me = this;
    
      // Set initial tab from startSection prop or default
      if (this.startSection) {
        this.activeTab = this.startSection;
      }
      
      // Debug: log the active tab
      console.log('Initial activeTab:', this.activeTab);
    },
    watch: {
      // Update active tab when startSection prop changes
      startSection: {
        handler(newValue) {
          if (newValue) {
            this.activeTab = newValue;
          }
        },
        immediate: true
      },
      queryDefinition:{
        handler:function(newValue) {
          Object.assign(this.localQueryDefinition, this.createLocationDefinition(newValue));
          
         // me.localQueryDefinition=newValue && JSON.parse(JSON.stringify(newValue))
        },
        deep: true
      },
     includes:{
          handler:function(newValue,oldValue) {
            var me=this;
            if (!newValue) newValue=[];
            newValue.forEach(function(d) {
                me.localQueryDefinition.include=VcListUtils.setValueInList(me.localQueryDefinition.include,d.id, d.value, false);
            })
           
            /*
            me.queryDefinition.include=newValue.reduce(function(a, d) {
              if (!d.value) return a;
              if (a) a+=",";
              return a+d.id;
            }, "");
            */
           
          },
          deep: true
      },
    },
    components: {
      ContentTypeChooser
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vc-bs .vh-75 {
  height: 60vh !important;
  min-height: 600px !important;
}
/*
.card-nav-link.selected {
    color: #00628b;
    pointer-events: none;
}


.nav-link.active {
  color: #0d6efd;
  background-color: #e7f1ff;
  border-color: #b6d7ff;
}


.accordion-button:not(.collapsed) {
  color: #0c63e4;
  background-color: #e7f1ff;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}

.accordion-button:not(.collapsed)::after {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  transform: rotate(-180deg);
}

.tab-pane {
  display: block !important; 
}


.tab-pane.active.show {
  display: block !important;
}


.accordion-collapse {
  transition: height 0.35s ease;
}*/
</style>
